import _ from 'lodash';
import clsx from 'clsx';
import { Field, useForm } from 'react-final-form';
import { OperatorsSelect } from '@/tools/OperatorsSelect.molecule';
import { getFormFieldProps, getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';
import type { OPERATOR } from '@/toolSelection/investigate.constants';

export interface OperatorSelectIF extends ValidatingFormComponent<any> {
  component: 'OperatorSelectFormComponent';
  operators: readonly OPERATOR[];
  disabled?: boolean;
  onChange: (entryCondition: any) => void;
  formattedOptions?: boolean;
  placeholder?: string;
}

export const OperatorSelectFormComponent: React.FunctionComponent<OperatorSelectIF> = (props) => {
  const { name, validation, extendValidation, testId, extraClassNames } = props;
  const defaultValidation = _.isEmpty;
  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);
  const formState = useForm().getState();

  return (
    <div className={clsx('mb8', extraClassNames)} data-testid={testId}>
      <Field name={name} validate={appliedValidation}>
        {({ input, meta }) => {
          const formFieldProps = getFormFieldProps(formState, input, meta, props);

          return (
            <OperatorsSelect
              {...formFieldProps}
              onChange={(operator) => {
                props.onChange(operator);
                input.onChange(operator?.value);
              }}
              appendToBody={true}
              showError={formFieldProps.showError}
            />
          );
        }}
      </Field>
    </div>
  );
};
